import PropTypes from 'prop-types'

/**
 * TempleKeeperBadge is implemented in plain JavaScript. This helper centralizes
 * prop type contracts using JSDoc + PropTypes so consumers share the same
 * expectations without TypeScript.
 */

/**
 * @typedef {('bronze'|'silver'|'gold'|'celestial')} KeeperTier
 */

/**
 * @typedef {Object} BadgeCopy
 * @property {string} title - Short label for the tier.
 * @property {string} description - Tooltip body copy that explains benefits.
 */

// Tier prop kept for backward compatibility but is now optional and unused
export const keeperTierPropType = PropTypes.oneOf(['bronze', 'silver', 'gold', 'celestial'])

export const badgeCopyPropType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
})

export const templeKeeperBadgePropTypes = {
  tier: keeperTierPropType, // Optional, kept for backward compatibility
  copy: badgeCopyPropType,
  showLabel: PropTypes.bool,
  tooltipId: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export const templeKeeperBadgeDefaultProps = {
  tier: undefined, // Optional, kept for backward compatibility
  copy: null,
  showLabel: true,
  tooltipId: undefined,
  className: '',
  onClick: undefined,
}

export const templeKeeperBadgeTypeHelpers = {
  keeperTierPropType,
  badgeCopyPropType,
  templeKeeperBadgePropTypes,
  templeKeeperBadgeDefaultProps,
}

export default templeKeeperBadgeTypeHelpers
